import { usePlayerStore } from "../state/playerStore";

// Shown until an operator pairs this device from the dashboard. Displays the
// pairing code (large, readable from across a room) and the device id prefix.

export function PairingScreen() {
  const pairing = usePlayerStore((s) => s.pairing);
  const notice = usePlayerStore((s) => s.notice);

  if (notice) {
    // The code on screen is no longer usable (e.g. its pairing response was lost);
    // say what the operator has to do instead of inviting them to type it.
    return (
      <div className="fill center pairing">
        <div className="brand">GoCityScreens player</div>
        <div className="status-text">{notice}</div>
        {pairing && <div className="pairing-meta">device {pairing.deviceId.slice(0, 8)}…</div>}
      </div>
    );
  }

  return (
    <div className="fill center pairing">
      <div className="brand">GoCityScreens player</div>
      <div className="pairing-label">Enter this code in your operator dashboard</div>
      <div className="pairing-code">{pairing?.pairingCode ?? "------"}</div>
      <div className="pairing-hint">Players → Register player → enter code → choose a screen</div>
      {pairing && <div className="pairing-meta">device {pairing.deviceId.slice(0, 8)}…</div>}
    </div>
  );
}
